import {CrudModel} from '@ngx-ivengi/crud';

export class Report extends CrudModel {

  public reportId: string; // Used for building links
  public name: string;
  public file: FileList;
  public fileId: string;
  public fileName: string;

  public setReportId(reportId: string): Report {
    if(typeof reportId === 'string') {
      this.reportId = reportId;
    }
    return this;
  }

  public setName(name: string): Report {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setFile(file: FileList): Report {
    if(file instanceof FileList) {
      this.file = file;
    }
    return this;
  }

  public setFileId(fileId: string): Report {
    if(typeof fileId === 'string') {
      this.fileId = fileId;
    }
    return this;
  }

  public setFileName(fileName: string): Report {
    if(typeof fileName === 'string') {
      this.fileName = fileName;
    }
    return this;
  }

  fromResponse(response: any): void {
    this
      .setId(response.id)
      .setReportId(response.id);

    if(typeof response.report === 'object') {
      this.setReportId(response.report.id);
      response = response.report;
    }

    if(response.file) {
      this
        .setFileId(response.file.id)
        .setFileName(response.file.name);
    }

    this
      .setName(response.name);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/report/report.model.ts